import { PUBLIC_HYDRATION_PROTOCOL_VERSION, createPublicHydrationProtocol, } from "@logscord/public-site/hydration";
export const LOGSCORD_PUBLIC_STATE_VERSION = PUBLIC_HYDRATION_PROTOCOL_VERSION;
function isLogscordPublicApplicationState(value) {
    return typeof value === "object"
        && value !== null
        && "locale" in value
        && typeof value.locale === "string"
        && "localeLocked" in value
        && typeof value.localeLocked === "boolean";
}
export function createLogscordPublicHydrationProtocol(buildId) {
    return createPublicHydrationProtocol({
        buildId,
        protocolVersion: LOGSCORD_PUBLIC_STATE_VERSION,
        validateApplicationState: isLogscordPublicApplicationState,
    });
}
//# sourceMappingURL=state.js.map